export default {
  title: 'Portail client',
  titlePrefix: 'au ',
  ErrorTitle: 'Erreur technique',
  ErrorMessage: 'Nous sommes désolés des inconvénients que cela peut vous causer.',
  ErrorRetryButton: 'Réessayer',
  NotFoundTitle: 'Page introuvable',
  NotFoundMessage: 'Désolé, la page a été déplacée ou supprimée.',
  NotFoundBackButton: 'Retour',
  copyright: `iA Gestion privée de patrimoine est une marque de commerce et un autre nom sous lequel iA Gestion privée de patrimoine inc. exerce ses activités. © ${new Date().getFullYear()} iA Gestion privée de patrimoine inc. Tous droits réservés.`,
  hrefLogoOcrcvm: 'https://www.ocri.ca/',
  altLogoOcrcvm: 'Logo de l’OCRCVM',
  ocrcvm: 'Rapport Info-conseiller de l’OCRI',
  hrefOcrcvm: 'https://www.ocri.ca/bureau-des-investisseurs/rapport-info-conseiller',
  memberOfCanadian: 'Fonds canadien de protection des investisseurs',
  hrefMemberOfCanadian: 'https://www.fcpi.ca/',
  cssFooterLogoMargin: '3px 0 0 42px',
  cssFooterLogoWidth: '230px',
};
